import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import * as Sentry from '@sentry/browser';
import * as SentryIntegrations from '@sentry/integrations';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { api, flashMessage, modal, stickyMessage } from './util';
import { medicalDeviceGroupDetail, medicalDeviceGroupList } from './medical-device-group';
import { procedureGroupDetail, procedureGroupList } from './procedure-group';
import { procedureDetail, procedureSearch } from './procedure';
import { procedureTag } from './procedure-tag';
import { productGroupDetail, productGroupList } from './product-group';
import { disChart, productGroupDisDetail } from './product-open-data';
import { medicalDeviceDistributionChart, medicalDeviceGroupDistributionDetail } from './medical-device-distribution';
import { productDetail, productSearch } from './product';
import { medicalDeviceDetail, medicalDeviceSearch } from './medical-device';
import { medicalDeviceRzproDetail, medicalDeviceRzproSearch } from './medical-device-rzpro';
import './libs/select2.min';

var initSentry = function () {
	// Do not run Sentry in dev env
	if (window.env === 'dev') {
		init();
		return;
	}

	Sentry.init({
		denyUrls: [/extensions\//i, /^chrome:\/\//i],
		dsn: 'https://bc29da2574684bce85e864746ef7adcf@o513715.ingest.sentry.io/5616090',
		tunnel: 'https://tuuuuuuuuuuuuunnel.cogvio.dev/',
		environment: window.env,
		integrations: [new SentryIntegrations.ExtraErrorData(), new TracingIntegrations.BrowserTracing()],
		tracesSampleRate: 0.2,
	});

	$(document).ajaxError(function (event, jqXHR, ajaxSettings, thrownError) {
		if (
			jqXHR.status === 500 || // is logged by Java
			jqXHR.status === 0 // abort
		) {
			return;
		}

		Sentry.captureException(thrownError || jqXHR.statusText, {
			extra: {
				type: ajaxSettings.type,
				url: ajaxSettings.url,
				data: ajaxSettings.data,
				status: jqXHR.status,
				error: thrownError || jqXHR.statusText,
				response: jqXHR.responseText !== undefined ? jqXHR.responseText.substring(0, 100) : 'Not defined',
			},
		});
	});

	var userInfo = $('.user-id').data();

	if (userInfo) {
		Sentry.setUser({
			id: userInfo['userId'],
			email: userInfo['userEmail'],
		});
	}

	init();
};

/**
 * Edge is weird browser and sometimes sends two `accessToken` cookies with different domains.
 * One with `.app.cogvio.com` and other with `app.cogvio.com`.
 * This deletes the `.app.cogvio.com` and ensures, only correct cookie remains.
 */
var deleteMultipleAccessTokens = function () {
	let cookies = document.cookie ? document.cookie.split('; ') : [];
	let accessTokens = [];

	for (let i = 0, l = cookies.length; i < l; i++) {
		let parts = cookies[i].split('=');
		let name = decodeURIComponent(parts.shift());
		let value = parts.join('=');

		if (name === 'accessToken') {
			accessTokens.push(value);
		}
	}

	if (accessTokens.length > 1) {
		// this actually works even without the `.` in the beginning, but let's make sure...
		document.cookie = `accessToken=; Max-Age=0; path=/; domain=.${location.hostname}`;
		Sentry.captureMessage(`Deleting multiple accessTokens${accessTokens.join(';')}`);
		location.reload();
	}
};

var init = function () {
	// Global initialization.
	api.init();
	procedureTag.init();
	modal.init();
	flashMessage.init();
	stickyMessage.init();

	$(document).on('api.error', function () {
		flashMessage.show('error', $('.app-settings').data('api-error-message'));
	});
	$(document).on('modal.shown', flashMessage.hide);
	$(document).on('flash.shown', modal.hide);

	// Authentication.
	$('.login-form').validateForm();
	$('.reset-password-form').validateForm();

	// Menu.
	var anchorMenuItem = $('header nav li a[href="/#procedure-groups"]');
	var selectAnchorMenuItem = function () {
		$('header nav a').removeClass('item-act');
		anchorMenuItem.addClass('item-act');
	};
	anchorMenuItem.click(selectAnchorMenuItem);

	if (window.location.pathname === '/' && window.location.hash === '#procedure-groups') {
		selectAnchorMenuItem();
	}

	// Fix select boxes in IE.
	$('select').change(function () {
		$(this).blur();
	});

	// Initialization of views.
	medicalDeviceGroupList.init();
	medicalDeviceGroupDetail.init();
	procedureGroupList.init();
	procedureGroupDetail.init();
	procedureSearch.init();
	procedureDetail.init();
	productGroupList.init();
	productGroupDetail.init();
	productGroupDisDetail.init();
	productSearch.init();
	productDetail.init();
	medicalDeviceSearch.init();
	medicalDeviceDetail.init();
	medicalDeviceRzproSearch.init();
	medicalDeviceRzproDetail.init();
	medicalDeviceGroupDistributionDetail.init();
	disChart();
	medicalDeviceDistributionChart();

	if (window.env === 'dev') {
		// eslint-disable-next-line no-console
		console.log('JS running in dev environment');
	}

	deleteMultipleAccessTokens();
};

$(document).ready(initSentry);
